/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, cap: NonNullable<unknown> }} Players_Cap_Warning_OrganizerInputs */



/**
* | output |
* | --- |
* | "Event full ({count}/{cap}). New sign-ups go to the waitlist." |
*
* @param {Players_Cap_Warning_OrganizerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_cap_warning_organizer = /** @type {((inputs: Players_Cap_Warning_OrganizerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Cap_Warning_OrganizerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Complet (${i?.count}/${i?.cap}). Les nouvelles inscriptions vont en liste d'attente.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Completo (${i?.count}/${i?.cap}). Las nuevas inscripciones van a la lista de espera.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Lotado (${i?.count}/${i?.cap}). Novas inscrições vão para a lista de espera.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Completo (${i?.count}/${i?.cap}). Le nuove iscrizioni finiscono in lista d'attesa.`)
	return /** @type {LocalizedString} */ (`Event full (${i?.count}/${i?.cap}). New sign-ups go to the waitlist.`)
});